import React from 'react';
import { Link } from 'react-router-dom';
import './FollowListModal.css';
import { DEFAULT_PROFILE_PICTURE } from '../constants/defaults';
import { useAuth } from '../contexts/AuthContext';

// Define the structure for a user in the list
interface ListUser {
  id: string;
  username: string;
  user_display_name: string; // Use the backend-provided display name
  picture: string | null; // Use the backend-provided picture URL (can be null)
  // metadata is no longer needed here for display purposes
}

interface FollowListModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  users: ListUser[] | null;
  isLoading: boolean;
  error: string | null;
}

const FollowListModal: React.FC<FollowListModalProps> = ({ 
  isOpen, 
  onClose, 
  title, 
  users, 
  isLoading, 
  error 
}) => {
  const { currentUser } = useAuth();

  if (!isOpen) {
    return null;
  }

  return (
    <div className="follow-list-modal-backdrop" onClick={onClose}>
      <div className="follow-list-modal-content" onClick={(e) => e.stopPropagation()}> 
        <div className="follow-list-modal-header">
          <h2>{title}</h2>
          <button onClick={onClose} className="close-button" aria-label="Close modal">&times;</button>
        </div>
        <div className="follow-list-modal-body">
          {isLoading ? (
            <p className="loading-message">Loading...</p>
          ) : error ? (
            <p className="error-message">{error}</p>
          ) : users && users.length > 0 ? (
            <ul className="user-list">
              {users.map((user) => {
                // Use the new fields directly
                const displayUserName = user.user_display_name;
                const avatarUrl = user.picture || DEFAULT_PROFILE_PICTURE;
                return (
                  <li key={user.id} className="user-list-item">
                    <Link 
                      to={user.id === currentUser?.uid ? '/profile' : `/profile/u/${user.username}`} 
                      onClick={onClose} 
                      className="user-link"
                    >
                      <img src={avatarUrl} alt={`${displayUserName}'s avatar`} className="user-avatar" />
                      <div className="user-info">
                        <span className="user-display-name">{displayUserName}</span>
                        <span className="user-username">@{user.username}</span>
                      </div>
                    </Link>
                  </li>
                );
              })}
            </ul>
          ) : (
            <p className="empty-message">No users to display.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default FollowListModal; 